"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ratio = _interopRequireDefault(require("../../../../shapes/ratio.shape"));

var _appActionMenu = _interopRequireDefault(require("../../../common/app-action-menu/app-action-menu"));

var _menuButton = _interopRequireDefault(require("../../../common/menu-button/menu-button"));

var _actionMenuTypes = _interopRequireDefault(require("../../../common/app-action-menu/action-menu-types"));

var _playButton = _interopRequireDefault(require("../../../common/play-button/play-button"));

var _ratioIcon = _interopRequireDefault(require("./ratio-icon/ratio-icon"));

var _videoDetails = _interopRequireDefault(require("./video-details/video-details"));

var _dashboardGridItemFeature = _interopRequireDefault(require("./dashboard-grid-item-feature.shape"));

class DashboardGridItem extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      showMenu: false
    });
    (0, _defineProperty2.default)(this, "onToggleMenu", () => {
      const {
        showMenu
      } = this.state;
      this.setState({
        showMenu: !showMenu
      });
    });
    (0, _defineProperty2.default)(this, "onActionSelect", ({
      value
    }) => {
      const {
        onEdit,
        onDuplicate,
        onDelete
      } = this.props;

      switch (value) {
        case _actionMenuTypes.default.EDIT:
          onEdit();
          break;

        case _actionMenuTypes.default.DUPLICATE:
          onDuplicate();
          break;

        case _actionMenuTypes.default.DELETE:
          onDelete();
          break;
      }
    });
  }

  render() {
    const {
      thumbnailUrl,
      onPlay,
      ratio,
      title,
      createdDate,
      publishButton,
      actionFeatures,
      onPublish
    } = this.props;
    const {
      showMenu
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-grid-item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-grid-item__thumbnail-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-grid-item__thumbnail"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "dashboard-grid-item__thumbnail-image",
      src: thumbnailUrl,
      alt: ""
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('dashboard-grid-item__overlay', {
        'dashboard-grid-item__overlay--visible': showMenu
      })
    }, /*#__PURE__*/_react.default.createElement(_playButton.default, {
      onClick: onPlay
    }), /*#__PURE__*/_react.default.createElement(_menuButton.default, {
      onClick: this.onToggleMenu,
      onClose: this.onToggleMenu,
      showMenu: showMenu
    }, /*#__PURE__*/_react.default.createElement(_appActionMenu.default, {
      onSelect: this.onActionSelect,
      items: actionFeatures
    }))), /*#__PURE__*/_react.default.createElement(_ratioIcon.default, {
      ratio: ratio
    }))), /*#__PURE__*/_react.default.createElement(_videoDetails.default, {
      title: title,
      createdDate: createdDate,
      onPublish: onPublish,
      publishButton: publishButton
    }));
  }

}

(0, _defineProperty2.default)(DashboardGridItem, "propTypes", {
  thumbnailUrl: _propTypes.default.string.isRequired,
  onPlay: _propTypes.default.func,
  ratio: _ratio.default.isRequired,
  onEdit: _propTypes.default.func,
  onDuplicate: _propTypes.default.func,
  onDelete: _propTypes.default.func.isRequired,
  onPublish: _propTypes.default.func.isRequired,
  title: _propTypes.default.string.isRequired,
  createdDate: _propTypes.default.number.isRequired,
  publishButton: _propTypes.default.string,
  actionFeatures: _propTypes.default.arrayOf(_dashboardGridItemFeature.default).isRequired
});
(0, _defineProperty2.default)(DashboardGridItem, "defaultProps", {
  onEdit: null,
  onDuplicate: null,
  onPlay: null,
  publishButton: 'Publish'
});
var _default = DashboardGridItem;
exports.default = _default;